import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import { cn } from './cn.js';
import { useOverlayContainer } from './overlay-container.js';
const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;
const TooltipContent = React.forwardRef(({ className, sideOffset = 4, ...props }, ref) => (_jsx(TooltipPrimitive.Portal, { container: useOverlayContainer(), children: _jsx(TooltipPrimitive.Content, { ref: ref, sideOffset: sideOffset, "data-slot": "tooltip-content", className: cn('z-50 overflow-hidden rounded-md border border-border bg-popover px-2.5 py-1 text-caption text-popover-foreground shadow-xs animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95', className), ...props }) })));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;
/**
 * The one-line tooltip. Needs a `TooltipProvider` above it (the shell mounts
 * one); 200 ms delay.
 */
export function Tip({ content, side = 'top', align = 'center', children, className }) {
    return (_jsxs(Tooltip, { delayDuration: 200, children: [_jsx(TooltipTrigger, { asChild: true, children: children }), _jsx(TooltipContent, { side: side, align: align, className: className, children: content })] }));
}
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
//# sourceMappingURL=tooltip.js.map